<template>
  <div class="b-calender-slider-by-server-data">
    <!-- selection: {{ selection }} -->
    <div class="b-filters__title">
      {{ titleString }}
    </div>

    <div class="b-calender__wrapper">
      <div
        :class="[
          miniCalendar
            ? 'b-calender__calender-holder--mini'
            : 'b-calender__calender-holder',
        ]">
        <Swiper
          ref="CalenderSwiper"
          :navigation="{
            nextEl: '.b-calender__next',
            prevEl: '.b-calender__prev',
          }"
          :pagination="{
            el: '.b-calender__pagination',
            type: 'bullets',
            clickable: true,
          }"
          slides-per-view="auto"
          :space-between="5"
          :breakpoints="breakpoints"
          @swiper="onSwiper">
          <SwiperSlide
            v-for="(date, index) in calendarData"
            :key="index"
            :class="[calendarSlideClass, todayClass(date)]">
            <label :for="`${inputId}-${date.id}`" class="e-calender__label">
              <input
                :id="`${inputId}-${date.id}`"
                v-model="selection"
                :disabled="date.disabled"
                name="calendar-slider-filters"
                :value="date.id"
                type="radio"
                @click="() => (selection = date.id)" />
              <div class="e-calender__day">
                <div v-if="date.currentDay" class="e-calender__today">
                  {{ todayString }}
                </div>
                <div class="e-calender__title">
                  {{ date.dayName }}
                </div>
                <div class="e-calender__number">
                  {{ date.currentDay }}
                </div>
                <div class="e-calender__month">{{ date.monthName }}</div>
              </div>
            </label>

            <!-- <div class="e-calender__el-holder">
              <label class="e-calender__day"


                <div v-if="!miniCalendar" class="b-calender__radio">
                  <div v-if="date.currentDay" class="b-calender--today">
                    σημερα
                  </div>
                  <div class="b-calender__title">5</div>
                  <div class="b-calender__number">18</div>
                  <div class="b-calender__title">ΙΟΥΛ</div>
                </div>
                <div v-else class="e-calender__day">
                  <div class="e-calender__title">initialDayName</div>
                  <div>day</div>
                </div>
              </label>
            </div> -->
          </SwiperSlide>
        </Swiper>
      </div>
      <div v-if="!miniCalendar && desktop" class="b-calender__slider-actions">
        <div
          class="swiper-button-next b-calender__next"
          @click="() => slider.slideNext()"></div>
        <div
          class="swiper-button-prev b-calender__prev"
          @click="() => slider.slidePrev()"></div>
      </div>
    </div>
    <div v-if="miniCalendar && !hideNavigation" class="p-movies__cta-holder">
      <button
        class="swiper-button-prev p-movies__prev-cta b-calender__prev"
        type="button"
        @click="() => slider.slidePrev()"></button>
      <button
        class="swiper-button-next p-movies__next-cta b-calender__next"
        type="button"
        @click="() => slider.slideNext()"></button>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import moment from 'moment-timezone'
import constants from '../../lib/constants'
import { makeId } from '../../lib/lib'
import {
  getDateDay,
  getDayName,
  getFormattedDate,
  getLocaleDateString,
  getMonthName,
} from '../../lib/date'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    modelValue: {
      default: '',
      type: String,
    },
    dates: {
      default() {
        return []
      },
      type: Array,
      required: true,
    },
    filtered: {
      default() {
        return []
      },
      type: Array,
    },
    miniCalendar: { default: false, type: Boolean },
    hideNavigation: { default: false, type: Boolean },
    todayString: { default: 'Today', type: String },
    breakpoints: {
      default() {
        return {}
      },
      type: Object,
    },
    local: {
      default: 'el',
      type: String,
    },
    dateFormateOptions: {
      default() {
        return {
          weekday: 'long',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }
      },
      type: Object,
    },
  },
  emits: ['filter-changed'],
  data() {
    return {
      inputId: makeId(),
      slider: null,
      desktop: false,
      selection: this.modelValue,
      calendarData: [],
    }
  },
  computed: {
    calendarSlideClass() {
      return this.miniCalendar
        ? 'e-calender e-calender--mini'
        : 'e-calender e-calender--large'
    },
    selectedDayString() {
      return this.dates.find((day) => day.value === this.selection)
    },
    titleString() {
      const dayStr =
        (this.selectedDayString && this.selectedDayString.display) ||
        this.dates[0].value
      const newDay = moment.tz(dayStr, constants.timezone).toDate()

      const monthName = getMonthName(newDay, this.local)
      const year = newDay.getFullYear()

      return `${monthName} ${year}`
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.selection = newVal
      },
    },
    selection: {
      handler(newVal) {
        this.$emit('filter-changed', newVal, 'dates')
        // this.$emit('update:modelValue', newVal, 'dates')
      },
    },
    filtered: {
      handler() {
        this.updateCalendar()
      },
    },
  },
  created() {
    this.setCalendar()
  },
  mounted() {
    this.assigntoViewports()
    window.addEventListener('resize', () => {
      this.assigntoViewports()
    })
  },
  methods: {
    assigntoViewports() {
      this.desktop = constants.is === 'desktop'
    },
    onSwiper(swiper) {
      this.slider = swiper
    },
    setCalendar() {
      this.calendarData = []
      const today = moment().tz(constants.timezone)

      for (const day of this.dates) {
        const newDay = moment.tz(day.display, constants.timezone).toDate()
        const isTodayDate =
          day.display.split('T')[0] === today.format('YYYY-MM-DD')
        const isDisabled = this.checkIfIsDisabled(day.value)
        this.calendarData.push({
          id: day.value,
          disabled: isDisabled,
          day: isTodayDate,
          dayName: getDayName(newDay, 'el')
            .slice(0, this.miniCalendar ? 1 : 3)
            .toLocaleUpperCase(),
          initialDayName: getDayName(newDay, 'el').slice(0, 1),
          monthName: getMonthName(newDay, 'el').slice(0, 4).toLocaleUpperCase(),
          currentDay: getDateDay(newDay),
          fullDate: getLocaleDateString(newDay),
          formattedDate: getFormattedDate(
            newDay,
            this.local,
            this.dateFormateOptions,
          ),
        })
      }
    },
    updateCalendar() {
      this.calendarData = this.calendarData.map((item) => {
        const isDisabled = this.checkIfIsDisabled(item.id)
        return {
          ...item,
          disabled: isDisabled,
        }
      })
    },
    checkIfIsDisabled(id) {
      if (!this.filtered.length) {
        return false
      }
      return this.filtered.every((item) => item.value !== id)
    },
    todayClass(date) {
      return date.day ? 'e-calender--current-today' : ''
    },
  },
}
</script>
